import { ReactNode } from "react";
import { PickerProject } from "./add-to-project-picker.types";
import { AddToProjectPickerContent } from "./add-to-project-picker-content";
import { useProjectPickerData } from "./use-project-picker-data";

interface AddToProjectPickerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  header: ReactNode;
  organisationId?: string;
  userId?: string;
  productId?: string;
  onAssign: (project: PickerProject) => void;
  onAlreadyAssigned?: (project: PickerProject) => void;
  onCreateNew: () => void;
  isAssigning?: boolean;
}

export const AddToProjectPicker = ({
  open,
  onOpenChange,
  header,
  organisationId,
  userId,
  productId,
  onAssign,
  onAlreadyAssigned,
  onCreateNew,
  isAssigning,
}: AddToProjectPickerProps) => {
  const { myProjects, sharedProjects, isLoading } = useProjectPickerData({
    organisationId,
    userId,
    productId,
    enabled: open && Boolean(organisationId && userId),
  });

  return (
    <AddToProjectPickerContent
      open={open}
      onOpenChange={onOpenChange}
      header={header}
      myProjects={myProjects}
      sharedProjects={sharedProjects}
      onAssign={onAssign}
      onAlreadyAssigned={onAlreadyAssigned}
      onCreateNew={onCreateNew}
      isAssigning={isAssigning}
      isLoading={isLoading || (open && !userId)}
    />
  );
};
